// src/pages/Obtener/DescargaSAE.js
import React, { useState } from "react";
import {
  Button,
  Stack,
  TextField,
  CircularProgress,
  Backdrop,
} from "@mui/material";
import { Search } from "@mui/icons-material";
import axios from "axios";
import Swal from "sweetalert2";

const DescargaSAE = () => {
  const [nombreArchivo, setNombreArchivo] = useState("");
  const [fileUrl, setFileUrl] = useState(null);
  const [loading, setLoading] = useState(false);

  const handleBuscar = async () => {
    if (!nombreArchivo.trim()) {
      Swal.fire(
        "Atención",
        "Por favor ingresa un nombre de archivo",
        "warning"
      );
      return;
    }

    try {
      setLoading(true);
      const response = await axios.get(
        `https://middlewarebackprd.azurewebsites.net/api/sharepoint/descargar/${nombreArchivo}`,
        { responseType: "blob" }
      );

      const contentType = response.headers["content-type"];
      const blob = new Blob([response.data], { type: contentType });
      const url = window.URL.createObjectURL(blob);

      if (contentType.includes("pdf")) {
        // mostrar en visor PDF
        setFileUrl(url);
      } else {
        // descargar si no es PDF
        const link = document.createElement("a");
        link.href = url;
        link.setAttribute("download", nombreArchivo);
        document.body.appendChild(link);
        link.click();
        link.remove();

        Swal.fire("Éxito", "Archivo descargado correctamente", "success");
      }
    } catch (error) {
      Swal.fire("Error", "No se pudo obtener el archivo", "error");
      console.error(error);
    } finally {
      setLoading(false);
    }
  };

  return (
    <div style={{ padding: "20px" }}>
      {/* Formulario */}
      <Stack direction="row" spacing={2} alignItems="center" marginBottom={2}>
        <TextField
          label="Nombre del documento"
          variant="outlined"
          size="small"
          value={nombreArchivo}
          onChange={(e) => setNombreArchivo(e.target.value)}
        />
        <Button
          variant="contained"
          color="primary"
          startIcon={<Search />}
          onClick={handleBuscar}
        >
          Buscar
        </Button>
      </Stack>

      {/* Visor PDF */}
      {fileUrl && (
        <div style={{ marginTop: "20px" }}>
          <iframe
            src={fileUrl}
            width="100%"
            height="600px"
            title="Visor de documento"
            style={{ border: "1px solid #ccc", borderRadius: "8px" }}
          ></iframe>
        </div>
      )}

      {/* Loading */}
      <Backdrop
        sx={{ color: "#fff", zIndex: (theme) => theme.zIndex.drawer + 1 }}
        open={loading}
      >
        <CircularProgress color="inherit" />
      </Backdrop>
    </div>
  );
};

export default DescargaSAE;
